const QUERIES = {
  USERS_LIST: 'users-list',
  PIECES_LIST: 'current-pieces',
  PRODUCT_LIST: 'products-list',
  CLIENT_LIST: 'clients-list',
  SUPPLIER_LIST: 'suppliers-list',
  DOCUMENT_LIST: 'documents-list',
  STOCK_MOVEMENT: 'stock-movement',
  SALES_DASHBOARD: 'sales-dashboard',
  CARDS_DASHBOARD: 'cards',
  CURRENT_PIECE: 'current-pieces',
}

export {QUERIES}
